module.exports = __webpack_public_path__ + "img/icon_cjwt01.4a10d3e9.png";